import React from 'react';
import WomenCategory from '../../../../Assets/StorefrontIcons/WomenCategory.svg';
import MenCategory from '../../../../Assets/StorefrontIcons/MenCategory.svg';
import FootwearCategory from '../../../../Assets/StorefrontIcons/FootwearCategory.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';

function CategoryButton() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`CATEGORY${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl select-none outline-none">
            <div className="w-full h-[100px] flex items-center justify-evenly rounded-md bg-[#EAEAEA] font-normal text-[10px] leading-5 text-[#121212]">
                <div className="flex flex-col items-center gap-1 px-2">
                    <div className="size-11 rounded-full overflow-hidden">
                        <img className='size-full object-cover' src={WomenCategory} alt="" />
                    </div>

                    <p>Women</p>
                </div>

                <div className="flex flex-col items-center gap-1 px-2">
                    <div className="size-11 rounded-full overflow-hidden">
                        <img className='size-full object-cover' src={MenCategory} alt="" />
                    </div>

                    <p>Men</p>
                </div>

                <div className="flex flex-col items-center gap-1 px-2">
                    <div className="size-11 rounded-full overflow-hidden">
                        <img className='size-full object-cover' src={FootwearCategory} alt="" />
                    </div>

                    <p>Footwear</p>
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Category</p>
        </button>
    );
}

export default CategoryButton;
